import mixpanel from "mixpanel-browser";
import { MIXPANEL_TOKEN } from "../config/config";

class Mixpanel {
  constructor(token) {
    mixpanel.init(token, {
      persistence: "localStorage",
    });
    window.mixpanel = mixpanel;
  }

  startSession(userId, obj) {
    if (userId) {
      mixpanel.identify(userId, obj);
    } else {
      const distinctId = mixpanel.get_distinct_id();
      localStorage.setItem("mixpanel_distinct_id", distinctId);
      mixpanel.identify(distinctId);
    }
  }

  track(event, payload) {
    mixpanel.track(event, payload);
  }

  identify(distinctId) {
    mixpanel.identify(distinctId);
  }

  alias(distinctId) {
    mixpanel.alias(distinctId);
  }

  getDistinctId() {
    return mixpanel.get_distinct_id();
  }
}

// export const mixPanelEnvironment = (process.env.REACT_APP_MODE === "production" || process.env.REACT_APP_MODE === "staging") && isAiSensy;

let mixpanelSession;
mixpanelSession = new Mixpanel(MIXPANEL_TOKEN);

export default mixpanelSession;
